import { useQuery } from "convex/react";
import { api } from "../../../convex/_generated/api";
import { useProject } from "@/hooks/project";
import { Card, PageHeader, Spinner } from "@/components/ui";

export function AuditPage() {
  const { project } = useProject();
  const log = useQuery(api.projects.auditLog, { projectId: project._id });
  if (!log) return <Spinner />;
  return (
    <div className="max-w-5xl">
      <PageHeader title="Audit log" sub="Every change to this project, newest first (last 300)." />
      <Card bodyClass="p-0">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left text-xs text-slate-500">
            <tr>
              <th className="px-4 py-2">When</th>
              <th className="px-4 py-2">Who</th>
              <th className="px-4 py-2">Action</th>
              <th className="px-4 py-2">Detail</th>
            </tr>
          </thead>
          <tbody>
            {log.map((r) => (
              <tr key={r._id} className="border-t border-slate-100">
                <td className="whitespace-nowrap px-4 py-1.5 text-slate-500">{new Date(r._creationTime).toLocaleString()}</td>
                <td className="px-4 py-1.5">{r.email}</td>
                <td className="px-4 py-1.5 font-medium">{r.action}</td>
                <td className="px-4 py-1.5 text-slate-600">{r.detail}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
